'use strict';

var createMiddleware = require('./middleware');

module.exports = {
  createMiddleware: createMiddleware
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/index.js
// module id = 256
// module chunks = 0